const EmployeeInfoReducer =(state=null, action)=>{
    switch(action.type){
      case "GET_EMPLOYEE_INFO":
          return state;
      case "SET_EMPLOYEE_INFO" :
          return action.info;
      case "NULL_EMPLOYEE_INFO" :
          return action.info;
      default:
          return state;
    }
  }
  export default EmployeeInfoReducer